import React, { useEffect } from "react";
import './App.css';
import InstagramFeed  from 'react-ig-feed'
import 'react-ig-feed/dist/index.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav} from 'react-bootstrap';
import { TwitterTimelineEmbed } from 'react-twitter-embed';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-68762-3');
ReactGA.pageview(window.location.pathname + window.location.search);


function App() {
  
  const googletag = window.googletag;

  const displayAd = (adID) => {  
    googletag.cmd.push(function() { googletag.display(adID); }); 
    //console.log("lolo");  
  }
  useEffect(() => {
    
    (async () => {
      //const $ = window.$;
      const play = window.play;
      var param = {
        url:'encoder3',
        autoPlay: 1
      }
      
      await play('player_envivo', param);
      
    })();

    displayAd();
    
  }, []);
  
  return (
    <>
        <div className="bg-event">
          <header className="bg-light">
            <section className="publicidad">
                <div id="dfp_top">{displayAd("dfp_top")}</div>
                <div id="dfp_topMobile">{displayAd("dfp_topMobile")}</div>
            </section>
            <Navbar bg="light" expand="lg">
              <Navbar.Brand className="logo-tvn" href="/portada/"> TELEVISIÓN NACIONAL DE CHILE</Navbar.Brand>
              <Nav.Link className="btn p-2 btn-secondary" href="http://www.tvn.cl/portada/">TVN.CL</Nav.Link>
              <Nav.Link className="ml-3 p-2 btn btn-secondary" href="http://www.24horas.cl/portada/">24HORAS.CL</Nav.Link>
            </Navbar>
          </header>
          <hr className="red-line"/>
          <hr className="blue-line"/>
          <div className="container-fluid px-4 px-lg-5">
            <div className="row gx-4 gx-lg-5 align-items-center">
              <div className="col-lg-12">
                  <img className="img-fluid rounded mb-4 mb-lg-0 banner-ppal" src="http://estaticos.tvn.cl/skins/web-assets/images/colocolo/header-colocolo-aniversario.png" alt="..." />
              </div>
            </div>
          </div>
          <div className="container px-4 px-lg-5">  
            <div className="row gx-4 gx-lg-5 align-items-center my-3">
                <div className="col-lg-8">
                  <h1 className="title-sing">SEÑAL EN VIVO</h1>
                  <div className="player-content">
                    <div id="player_envivo"></div> 
                  </div>
                </div>
                <div className="col-lg-4">
                  <img className="img-fluid rounded mb-4 mb-lg-0 imgFull" src="https://estaticos.24horas.cl/skins/2021/30libertadores/twitter30libertadores.png"/>
                  <div className="content-twit">
                    <TwitterTimelineEmbed 
                      sourceType="profile" 
                      theme="dark" 
                      noHeader 
                      screenName="24HDeportesTVN" 
                      options={{height: 400}} 
                    />                    
                  </div>
                </div>
            </div>
            <div className="row gx-4 gx-lg-5 align-items-center my-5 pb-5">
              <div className="col-md-12 mb-12">
                <a href="https://www.instagram.com/24horasdeportes/" target="_blank">
                  <h1 className="title-info">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                      <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
                    </svg>
                      &nbsp; 24horasdeportes
                    </h1>
                </a>
              </div>
              <div className="col-lg-12 insta-iframe">
                <iframe src="https://cdn.lightwidget.com/widgets/bed9f7d7782e5458bd61ba0da7889768.html" scrolling="no" allowtransparency="true" className="lightwidget-widget"></iframe>
              </div>
            </div>
          </div>
      </div>
    </>
  );
}

export default App;

